import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
  Textarea,
} from "@fluentui/react-components";
import { DeleteDismissFilled } from "@fluentui/react-icons";
import { toast } from "components/FluentToast";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRemindersStore } from "store/RemindersStore";

export const DeleteReminderEntryDialog = () => {
  const [
    { deleteReminderEntryDialog, deleteReminderEntryStatus, reminderEntries },
    { setRemindersStoreValue, setRemindersStoreValues, deleteReminderEntry },
  ] = useRemindersStore();

  const isLoading = deleteReminderEntryStatus === "loading";
  const [comment, setComment] = React.useState("");
  const { t } = useTranslation();

  return (
    <Dialog open={deleteReminderEntryDialog.isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("pct.deleteReminderEntry.label")}</DialogTitle>
          <DialogContent>
            {t("pct.deleteReminderEntryConfirm.label", {
              paymentReferenceNumber: reminderEntries.find((el) => {
                return (
                  el.reminderEntryId ===
                  deleteReminderEntryDialog.reminderEntryId
                );
              })?.reminderEntryComment,
            })}
            <VSpace height={20} />
            <div>
              <label>{t("pct.comment.label")}</label>
              <VSpace height={5} />

              <Textarea
                style={{ width: "100%" }}
                rows={6}
                value={comment}
                disabled={isLoading}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <VSpace height={20} />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isLoading}
              onClick={() => {
                setRemindersStoreValue("deleteReminderEntryDialog", {
                  isOpen: false,
                  ReminderEntry: null,
                  reminder: null,
                });
              }}
            >
              {t("pct.close.label")}
            </Button>
            <Button
              appearance="primary"
              disabled={isLoading}
              icon={
                isLoading ? (
                  <Spinner size="tiny" />
                ) : (
                  <DeleteDismissFilled fontSize={16} />
                )
              }
              onClick={() => {
                deleteReminderEntry(
                  {
                    ReminderEntryId: deleteReminderEntryDialog.reminderEntryId,
                    reminderId: deleteReminderEntryDialog.reminderId,
                    comment: comment,
                    rowVersion: reminderEntries.find((el) => {
                      return (
                        el.reminderEntryId ===
                        deleteReminderEntryDialog.reminderEntryId
                      );
                    })?.rowVersion,
                  },
                  (row) => {
                    setRemindersStoreValues({
                      deleteReminderEntryDialog: {
                        isOpen: false,
                        ReminderEntryId: null,
                        reminderId: null,
                      },
                      reminderEntries: reminderEntries.map((el) => {
                        if (el.reminderEntryId === row.reminderEntryId) {
                          return {
                            selected: false,
                            edited: false,
                            changes: [],
                            ...row,
                          };
                        } else {
                          return el;
                        }
                      }),
                    });
                    toast.success(t("greco.success"));
                    //loadReminders({ reset: true, delay: true });
                  }
                );
              }}
            >
              {t("pct.delete.label")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
